/**
 * 考试列表
 * @author jzhu
 * @date 2020-02-14
 */

import React from 'react';
import _ from 'lodash'
import {connect} from 'dva';
import {modelUtils} from '@/utils';

import {utils_tool, component_tool, framework_tool} from '@/tool';

let {Session} = utils_tool;
//import '../../../../styles/containers/online/exam/index.less'
import {ChapterPreview, LookPreview, BankQuestionLook} from '../../../online'

import classnames from 'classnames';
import './style.less';
import {Form, Spin} from 'antd'

const {
  WizButton, WizRow, WizCol, WizNotice, WizIcon, WizTypography, WizSelect, WizInput, WizModalForm, WizModal, WizAlert,
  WizTable, WizDataTable, WizDropdown, WizMenu, WizInputNumber, WizPagination, WizCustomSteps,WizTooltip
} = component_tool;
import {WizTableForm} from '@/containers/common'


import {
  staticwizTabelColumns,
  dynamicWizTableColumns,
  dynamicWizModalFormColumns,
} from './columns';
import ExamQuestionImport from "./examQuestionImport";
import moment from "moment";


const {Text} = WizTypography;
let WizForm = Form
let Item = Form.Item
const WizItem = WizMenu.Item
const {WizContainer, ossFileUtils} = framework_tool;
let Option = WizSelect.Option


const getParamRecord = (history) => {
  let record = {}
  let id = 0
  let copyExam = false
  let copyExamId = 0
  let type = ""
  let pathUrl = ''
  if (history.location) {
    if (history.location.pathname === '/online/exam/examChapter') {
      if (history.location && history.location.record) {
        id = history.location.record['id']
        copyExam = history.location.record['copyExam']
        copyExamId = history.location.record['copyExamId']
        type = history.location.record['type']
        pathUrl = history.location.record['pathUrl']
        record = {id, copyExam, copyExamId, type,pathUrl}
        Session.set('examChapterInfo', record)
        Session.set('examInfoOrign', history.location.record)
      } else {
        record = Session.get('examChapterInfo') || 0
      }
    }
  } else {
    record = Session.get('examChapterInfo') || 0
  }
  return record
}
const getExamOrign = () => {
  let record ={}
  record = Session.get('examInfoOrign') || 0
  return record;
}
class ExamChapter extends WizContainer {
  componentName = 'examChapter';

  constructor(props) {
    super(props);
    const {id, copyExam, copyExamId, type,pathUrl} = getParamRecord(props.history)
    this.state = {
      record: {}, //当前选中章节的这条记录
      id,
      copyExam,
      copyExamId,
      type,
      pathUrl,
      currentIndex: -1, //当前选中章节项的索引
      data: [], //所有的章节信息
      questionTabelForm: [],//选择题目tabel中的数据
      categoryTabelForm: [],//分类tabel中的数据
      dynamicWizTableInfo: [],
      questionKey: new Date().getTime(),
      questionModalFormVisible: false,//题目是否显示状态
      categoryModalFormVisible: false,//题目分类是否显示状态
      previewPModalFormVisible: false,//题目查看显示状态
      lookModalFormVisible: false,//题目预览显示状态
      lookBankQUestionVisible: false,//题目查看状态
      bankQUestionData: {},//题目查看状态
      lookModalKey: new Date().getTime(),
      previewnKey: new Date().getTime(),
      chaptersKey: new Date().getTime(),
      text: null,//章节提示信息
      examQuestionImportVisible: false,

    };
    this.count = 0//符合题型的题目数
    this.scoreCount = 0 //题目总分
  }

  _componentDidMount() {
    const {id, copyExam, copyExamId, type} = this.state
    if ('temp' === type) {
      this.doActions([
        {
          path: 'examTemplate/chapterInfo',
          payload: {
            key: 'examTemplateChapter',
            apiParams: {id: copyExamId}
          }
        },
      ]);
    } else {
      this.doActions([
        {
          path: 'exam/chapterInfo',
          payload: {
            key: 'chapterInfoKey',
            apiParams: {
              id: copyExam ? copyExamId : id
            }
          }
        },
      ]);
    }
    const arr = [];
    this.setState({
      data: arr
    });
  }

  //START propsAndStateOnChange
  propsAndStateOnChange = {
    questionTabelForm: this._questionTabelForm.bind(this),
    categoryTabelForm: this._categoryTabelForm.bind(this),
    saveExamReturn: this._saveExamReturn.bind(this),
    saveExamNext: this._saveExamNext.bind(this),
    chapterInfo: this._chapterInfo.bind(this),
    examDetailInfo: this._examDetailInfo.bind(this)
  };

  _saveExamReturn(nextProps, nextState) {
    let {saveExamReturn} = nextProps
    if (saveExamReturn && saveExamReturn['success']) {
      wizNotice.success(saveExamReturn['msg'])
      this.jumpPage('replace', '/online/exam');
      return true
    } else {
      wizNotice.error(saveExamReturn && saveExamReturn['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _examDetailInfo(nextProps, nextState) {
    let record = getExamOrign();
    const {authenticationCount,doingAuth,spaceTime} = record;
    if (!nextProps.location.record) {
      record = nextProps.examDetailInfo.data
    }
    const {startDate,endDate}= record
    record['startDate'] = moment(startDate).format('YYYY-MM-DD HH:mm:ss')
    record['endDate'] = moment(endDate).format('YYYY-MM-DD HH:mm:ss')
    let pathname = 'examDetailAdd'
    if (this.state.pathUrl === 'exam/updateExam') {
      pathname = 'examDetailUpd'
    }
    let {examDetailInfo} = nextProps
    let data = examDetailInfo.data
    record['categoryType'] = data.categoryType
    record['totalScore'] = data.totalScore
    if (examDetailInfo && examDetailInfo['success']){
      record = data;
      record['authenticationCount'] = authenticationCount;
      record['doingAuth'] = doingAuth;
      record['spaceTime'] = spaceTime;
      this.jumpPage(
        'replace',
        '/online/exam/'+pathname,
        {id: this.state.id,...record}
      )
      return true;
    }
  }

  _saveExamNext(nextProps, nextState) {
    let {saveExamNext} = nextProps
    if (saveExamNext && saveExamNext['success']) {
      wizNotice.success(saveExamNext['msg'])

      this.jumpPage(
        'push',
        '/online/exam/examAuth',
        {id: this.state.id, copyExam: nextState['copyExam'], copyExamId: nextState['copyExamId']}
      )
      return true
    } else {
      wizNotice.error(saveExamNext && saveExamNext['msg'] || '操作失败,请稍后尝试')
      return false
    }
  }

  _chapterInfo(nextProps, nextState) {
    let chapterInfo = nextProps['chapterInfo'];
    this._updateStateForChapterInfo(chapterInfo, nextState)
    return true
  }

  _updateStateForChapterInfo(chapterInfo, nextState = {}) {
    if (chapterInfo && chapterInfo['success']) {
      let data = []
      if (chapterInfo['data'] && chapterInfo['data'] instanceof Array) {
        //data = Object.assign([],chapterInfo['data'])
        chapterInfo.data.forEach((v, index) => {
          let value = {...v}
          value['order'] = index
          if (value['questionTabelForm'] && value['questionTabelForm'] instanceof Array) {
            value['questionTabelForm'].forEach((tabel, key) => {
              tabel['typeChar'] = this._getValue('type', tabel['type'])
              tabel['difficultyTitle'] = this._getValue('difficulty', tabel['difficulty'])
              tabel['order'] = key
              tabel['rowkey'] = tabel['id']
              tabel['id'] = tabel['id']
            })
          }
          if (value['categoryTabelForm'] && value['categoryTabelForm'] instanceof Array) {
            value['categoryTabelForm'].forEach((categoryTabel, key) => {
              let categoryIds = categoryTabel['categoryIds']
              let categoryNames = categoryTabel['categoryNames']
              let ownCactegoryInfo = [{
                key: categoryIds,
                title: categoryNames,
                parentTitle: categoryNames,
                label: categoryNames,
                value: categoryIds
              }]
              categoryTabel['questionCategory'] = ownCactegoryInfo
              categoryTabel['questionCategoryTitle'] = categoryNames
              categoryTabel['difficultyTitle'] = this._getValue('difficulty', categoryTabel['difficulty'])
              categoryTabel['typeTitle'] = this._getValue('type', categoryTabel['type'])
              categoryTabel['order'] = key

            })
          }
          data.push(value)
        })
      }

      nextState.data = data
      if (data && data.length) {
        let val
        let currentIndex = this.state.currentIndex
        if (currentIndex === -1 || currentIndex >= data.length) {
          val = data[0]
          currentIndex = 0
        } else {
          val = data[currentIndex]
        }
        if (val) {
          nextState.record = val
          nextState.questionTabelForm = val.questionTabelForm ? val.questionTabelForm : []
          nextState.categoryTabelForm = val.categoryTabelForm ? val.categoryTabelForm : []
          nextState.currentIndex = currentIndex
          nextState.text = null
        }
      } else {
        nextState.record = {}
        nextState.questionTabelForm = []
        nextState.categoryTabelForm = []
        nextState.currentIndex = -1
        nextState.text = null
      }
    }
    return nextState
  }


  _questionTabelForm(nextProps, nextState) {
    if (nextState.currentIndex !== -1) {
      nextState.record['questionTabelForm'] = nextState.questionTabelForm
      nextState.data[nextState.currentIndex]['questionTabelForm'] = nextState.questionTabelForm
    }
    return true;
  }

  _categoryTabelForm(nextProps, nextState) {
    if (nextState.currentIndex !== -1) {
      nextState.record['categoryTabelForm'] = nextState.categoryTabelForm
      nextState.data[nextState.currentIndex]['categoryTabelForm'] = nextState.categoryTabelForm
    }
    return true;
  }

  //END propsAndStateOnChange

  //章节按钮校验
  check = record => {
    if (record.order < 0) {
      WizNotice.warn('请选择章节')
      return false
    }
    return true;
  };

  //章节部分点击事件
  handleClick = (val, index) => {
    this.setState({
      record: val,
      questionTabelForm: val.questionTabelForm ? val.questionTabelForm : [],
      categoryTabelForm: val.categoryTabelForm ? val.categoryTabelForm : [],
      currentIndex: index,
      text: null,
    });
  };

  //章节删除按钮点击事件
  handleDelete = _ => {
    const {record, data,currentIndex} = this.state;
    if (!this.check(record)) return false;
    const filterData = data.filter((val,index )=> index !== currentIndex).map((val,index )=>{
      val['order'] = index
      return val
    });
    this.setState({
      data: filterData,
      record: {},
      currentIndex: -1
    });
  };

  //章节移动事件
  handleMove = flag => {
    const {record, currentIndex, data} = this.state;
    if (!data || !data.length || !data[0]) {
      WizNotice.warn('请选中章节再移动');
      return false;
    }
    if (!this.check(record)) return false;
    if (flag === -1) {
      //上移
      if (currentIndex !== 0) {
        //如果不是第一项
        const temp = data[currentIndex];
        data[currentIndex] = data[currentIndex - 1];
        data[currentIndex - 1] = temp;
        this.setState({
          data,
          record: temp,
          currentIndex: currentIndex - 1
        });
      } else {
        //否则
        const filterData = data.concat([data.shift()]);
        this.setState({
          data: filterData,
          record: filterData[filterData.length - 1],
          currentIndex: filterData.length - 1
        });
      }
    } else if (flag === 1) {
      //下移
      if (!this.check(record)) return false;
      if (currentIndex !== data.length - 1) {
        //如果不是最后一项
        const temp = data[currentIndex];
        data[currentIndex] = data[currentIndex + 1];
        data[currentIndex + 1] = temp;
        this.setState({
          data,
          record: temp,
          currentIndex: currentIndex + 1
        });
      } else {
        //否则
        const filterData = [data.pop(), ...data];
        this.setState({
          data: filterData,
          record: filterData[0],
          currentIndex: 0
        });
      }
    } else {
      WizNotice.warn('参数不合法');
    }
  };

  //章节列表
  _renderChapters(record, data = [],currentIndex) {
    if (data.length) {
      return data.map((val, index) => {
        let className = classnames(
          'chapter-item',
          index === currentIndex? 'active' : ''
        )
        return (
          <li key={currentIndex + '@' + index} className={className} onClick={() => this.handleClick(val, index)}>
            <span className='badge'>{this._getValue('chapter', val.type)}</span>
            {val.title}
          </li>
        )
      })
    }
    return null
  }

  handleMenuClick(e) {
    const {data} = this.state
    let addData = Object.assign([], data)
    let length = data.length
    if (e.key === 'static') {
      //新增key固定为0
      addData.push({
        key: 0,
        type: 1,
        title: '',
        order: length
      });
    } else if (e.key === 'dynamic') {
      addData.push({
        key: 0,
        type: 2,
        title: '',
        order: length
      });
    } else if (e.key === 'multiple') {
      addData.push({
        key: 0,
        type: 0,
        title: '',
        order: length
      });
    }
    this.setState({
      data: addData
    });
  }

  //考试章节左侧栏
  _renderChapterMenu() {
    const menu = (
      <WizMenu onClick={this.handleMenuClick.bind(this)}>
        <WizItem key="static">
          固定章节
        </WizItem>
        <WizItem key="dynamic">
          随机章节
        </WizItem>
        <WizItem key="multiple">
          综合章节
        </WizItem>
      </WizMenu>
    );
    const {record, data,currentIndex} = this.state;
    return (
      <div className='chapter'>
        <div className='chapter-title'>{'考试章节'}</div>
        <div className='chapter-body'>
          <div className='operate'>
            <WizDropdown overlay={menu}>
              <WizButton type='link'>
                <WizIcon className='icon-add' type='plus-circle'/>
              </WizButton>
            </WizDropdown>
            <WizButton type='link' onClick={() => this.handleMove(-1)}>
              <WizIcon className='icon-circle' type='up-circle'/>
            </WizButton>
            <WizButton type='link' onClick={() => this.handleMove(1)}>
              <WizIcon className='icon-circle' type='down-circle'/>
            </WizButton>
            <WizButton type='link' onClick={() => this.handleDelete()}>
              <WizIcon className='icon-delete' type='delete'/>
            </WizButton>
          </div>

          <ul className='chapter-items'>
            {this._renderChapters(record, data,currentIndex)}
          </ul>
        </div>
      </div>
    )
  }

  //题目类型对应
  _getValue(type, key) {
    const values = {
      type: {
        0: '单选题',
        1: '多选题',
        2: '判断题',
        3: '填空题',
        4: '主观题'
      },
      difficulty: {
        0: '低',
        1: '中',
        2: '高',
      },
      chapter: {
        0: '综合',
        1: '固定',
        2: '随机',
      }
    }
    return values[type][key]
  }

  //选择题目分类按钮事件
  addCategoryEvent = () => {
    this.setState({
      dynamicWizTableInfo: [],
      categoryModalFormVisible: true,
    });
  }
  //选择题目按钮事件
  addQuestionEvent = () => {
    this.setState({
      questionModalFormVisible: true,
      questionKey: new Date().getTime(),
    });
  }
  //选择题目弹出框取消按钮事件
  _questionCancel = (obj, e) => {
    this.setState({
      questionModalFormVisible: false,
    });
  }
  //选择题目弹出框确定按钮事件
  _questionSubmit = (obj, e) => {
    if (obj['valueRows'] && obj['valueRows'] instanceof Array && obj['valueRows'].length > 0) {
      obj['valueRows'].forEach((key, index) => {
        key['order'] = index
        key['typeChar'] = this._getValue('type', key['type'])
        key['difficultyTitle'] = this._getValue('difficulty', key['difficulty'])
        if (!key['questionType']) {
          key['questionType'] = 0
        }
      });
    }
    this.setState({
      questionModalFormVisible: false,
      questionTabelForm: obj['valueRows']
    });
  }

  //题目分类编辑
  editRow(record) {
    //const { categoryTabelForm } = this.state;
    this.setState({
      dynamicWizTableInfo: record,
      categoryModalFormVisible: true
    })

  }

  //题目分类删除
  deleteDynamicRow(record) {
    const {categoryTabelForm} = this.state;

    let forms = [];
    categoryTabelForm.forEach(e => {
      if (e['order'] !== record.order) {
        forms.push(e);
      }
    });
    this.setState({
      categoryTabelForm: forms,
    })

  }

  //题目表单行删除
  deleteRow(record) {
    const {questionTabelForm} = this.state;

    let forms = [];
    questionTabelForm.forEach(e => {
      if (e['order'] !== record.order) {
        forms.push(e);
      }
    });

    this.setState({
      questionTabelForm: forms,
    })
  }

  titleValidate(value) {
    let errorMsg = null
    let pattern = /^[^\s]*$/
    if (value) {
      if (pattern.test(value)) {
      } else {
        errorMsg = '章节名称包含空格'
      }
    } else {
      errorMsg = '章节名称不能为空'
    }
    return errorMsg
  }

  scoreValidate(value) {
    let errorMsg = null
    let pattern = /^(([0-9][0-9]*)|(([0]\.5|[1-9][0-9]*\.5)))$/

    if (pattern.test(value)) {
      if (value > 100) {

        errorMsg = '每题分数必须小于100'
      }
    } else {
      errorMsg = '每题分数必须大于等于0且为0.5的倍数'
    }
    return errorMsg
  }

  //固定章节名称change事件
  _handleTitleChange(event) {
    const {record, data, currentIndex, text} = this.state;
    if (event && event.target) {
      let value = event.target.value
      if (currentIndex !== -1 && data[currentIndex]) {
        data[currentIndex]['title'] = value
        data['title'] = value
        let errorMsg = this.titleValidate(value)
        //静态章节set静态章节的reocrd
        this.setState({
          data: data,
          chaptersKey:new Date().getTime(),
          record: {...record, title: value},
          text: errorMsg,
        })

      }
    }
  }

  //固定章节每题分数change事件
  _handleScoreChange(value) {
    const {record, data, currentIndex} = this.state;
    let copyData = Object.assign([], data)
    if (currentIndex !== -1 && data[currentIndex]) {
      let convertValue = value ? value : 0
      copyData[currentIndex]['score'] = convertValue
      copyData['score'] = convertValue
      let errorMsg = this.scoreValidate(convertValue)
      this.setState({
        data: copyData,
        chaptersKey:new Date().getTime(),
        record: {...record, score: convertValue},
        text: errorMsg,
      })
    }
    //}
  }

  /**
   * 获取表单模态框属性（添加随机抽题章节内容）
   */
  _getModalDynamicProps = (record, visible, rows) => {

    return {
      title:'选择题目分类',
      record,
      rowKey: "id",
      showNum: false,
      selectType: "checkbox",
      isScroll: false,
      visible: visible,
      columns: dynamicWizModalFormColumns(this, record),
      modalOpts: {
        width: 600
      },
      onCancel: () => {
        this.setState({
          //record: {},
          categoryModalFormVisible: false
        });
      },
      onSubmit: values => {
        const {categoryTabelForm} = this.state
        let copyForm = Object.assign([], this.state.categoryTabelForm)
        if (values.total && values.total > this.count) {

          wizNotice.error('抽题总数大于符合题目数')
          return false;
        }
        let inArray = false
        let copyInfo = {
          key: categoryTabelForm.length,
          categoryIds: values['questionCategory'][0]['value'],
          id: values.id,
          order: values.order,
          total: values.total,
          type: values.type,
          typeTitle: this._getValue('type', values.type),
          difficulty: values.difficulty,
          difficultyTitle: this._getValue('difficulty', values.difficulty),
          questionCategoryTitle: values['questionCategory'][0]['parentTitle'],
          questionCategory: values['questionCategory'],
        }
        //新增
        if (!values['order'] && values['order'] !== 0) {
          for (let i = 0; i < copyForm.length; i++) {
            //题目分类与题型相同的情况
            if (copyForm[i]['questionCategory'][0]['value'] === values['questionCategory'][0]['value']
              && copyForm[i]['type'] === values['type'] && copyForm[i]['difficulty'] === values['difficulty']) {
              wizNotice.error('同一题目分类不能存在相同的题型')
              return false;
            }
          }
          copyInfo = {...copyInfo, order: copyForm.length}
          inArray = false
          //修改
        } else {
          for (let i = 0; i < copyForm.length; i++) {
            //题目分类与题型相同的情况
            if (values['order'] !== copyForm[i]['order']) {
              if (copyForm[i]['questionCategory'][0]['value'] === values['questionCategory'][0]['value']
                && copyForm[i]['type'] === values['type'] && copyForm[i]['difficulty'] === values['difficulty']) {
                wizNotice.error('同一题目分类不能存在相同的题型')
                return false;
              }
            } else {
              copyForm[i] = copyInfo
              inArray = true
            }
          }
        }
        if (!inArray) {
          copyForm.push(copyInfo);
        }

        this.setState({
          //record: {},
          categoryTabelForm: copyForm,
          categoryModalFormVisible: false
        });
      }
    };
  }

  //综合章节form
  _renderMultipleTable() {
    const {record, currentIndex, data} = this.state;
    let form
    if (record['tabelType'] === 'static') {

      form = this._questionModalForm()
    } else if (record['tabelType'] === 'dynamic') {
      form = this._categoryModalForm()
    }
    let copyRecord = Object.assign({}, record)
    return (
      <>
        <div style={{marginTop: 15, marginBottom: 15}}>
          <WizButton.Group>
            <WizButton type={copyRecord['tabelType'] === 'static' ? 'primary' : 'default'} onClick={() => {
              copyRecord['tabelType'] = 'static'
              data[currentIndex] = copyRecord
              this.setState({record: copyRecord})
            }}>
              固定题目
            </WizButton>
            <WizButton type={copyRecord['tabelType'] === 'dynamic' ? 'primary' : 'default'}
                       onClick={() => {
                         copyRecord['tabelType'] = 'dynamic'
                         data[currentIndex] = copyRecord
                         this.setState({record: copyRecord})
                       }}>
              随机抽题
            </WizButton>
          </WizButton.Group>
        </div>
        {form}
      </>
    )

  }

  /**
   * 题目查看按钮事件
   * @param {*} record
   */
  _onLookBankQuestion(record) {
    this.setState({
      bankQUestionData: record,
      lookBankQUestionVisible: true,
    })
  }

  _renderBtn = (value, valueRows) => {
    return (

      <WizButton
        icon="plus"
        type="primary"
        onClick={() => this.addQuestionEvent()}
        style={{marginTop: 15, marginBottom: 15}}
      >
        添加题目
      </WizButton>
    )
  }

  _titleModalForm() {

    const {questionTabelForm, categoryTabelForm, record, text} = this.state;
    let sum = 0
    let sumQuestion = 0
    let style = null
    let errorMsg = text ? text : this.titleValidate(record.title)
    errorMsg = errorMsg ? errorMsg : this.scoreValidate(record.score)
    if (errorMsg) {
      style = {color: 'red'}
    } else if (record.score || record.score==0) {
      sum = questionTabelForm.length * record.score
      sumQuestion = questionTabelForm.length
      if (categoryTabelForm) {
        categoryTabelForm.forEach(form => {
          sumQuestion = sumQuestion + form.total * 1
          sum = sum + form.total * record.score
        })
      }
    }
    return (
      <>
        <div className="form-control">
          <div className="form-title"><Text strong>名称 </Text></div>
          <div style={{width: 180}} className="form-input">
            <WizInput
              key={record.order}
              defaultValue={record.title}
              maxLength={10}
              onChange={event => this._handleTitleChange(event)}
              placeholder='请输入章节名称'/>
          </div>
        </div>
        <div className="form-control">
          <div className="form-title"><Text strong>每题分数 </Text></div>
          <div className="form-input"><WizInputNumber
            style={{'width': '180px'}}
            max={99.5}
            key={record.order}
            defaultValue={record.score}
            value={record.score}
            onChange={event => this._handleScoreChange(event)}
            placeholder='请输入分数'/></div>
        </div>

        <div style={{marginTop: 15}}><Text style={style}
                                           strong>{!errorMsg ? '共' + sumQuestion + '题,总分' + sum + '分' : errorMsg}  </Text>
        </div>
      </>)
  }

  _selectItem = (item) => {
    item.typeChar = this._getValue('type', item.type)
    return (
      <WizRow>
        <WizCol>
          <WizTooltip title={item.typeChar + '  ' + item.number} placement="topLeft" >{item.typeChar + '  ' + item.number}</WizTooltip>
        </WizCol>
      </WizRow>
    )
  }


  _renderStaticTable() {
    const {questionModalFormVisible,data, lookBankQUestionVisible,currentIndex, bankQUestionData, previewPModalFormVisible, questionTabelForm, categoryTabelForm, record, questionKey, text, previewnKey, examQuestionImportVisible} = this.state;

    let questionIdList = data?.map((val, index) => {
      if(index!=currentIndex){
       return val?.questionTabelForm?.map(p => p.id) || []
      }
      return []
    }) || [];
    let notInQuestionIds = _.flatMap(questionIdList).join(',')

    const questionConfig = WizTableForm.Config.question(this, {apiParams: {state: 1,notInQuestionIds},path:'bankQuestion/normalListByPage'})
    let initialValue = questionTabelForm.map(p => p.id)
    return (
      <>
        <div>
          <WizTableForm key={questionKey} {...questionConfig} showModal={true} visible={questionModalFormVisible}
                        selectType={'checkbox'} initRows={questionTabelForm} value={initialValue}
                        onSubmit={this._questionSubmit}
                        onCancel={this._questionCancel}
                        renderValue={this._renderBtn}
                        selectItem={this._selectItem}
          />
          <WizButton
            onClick={() => {
              let errorMsg = text ? text : this.titleValidate(record.title)
              errorMsg = errorMsg ? errorMsg : this.scoreValidate(record.score)
              if (errorMsg) {
                wizNotice.error(errorMsg)
              } else if (questionTabelForm && questionTabelForm.length > 0) {
                this.setState({previewPModalFormVisible: true, previewnKey: new Date().getTime()})
              } else {
                wizNotice.error("请设置章节题目后查看")
              }
            }}
            style={{marginLeft: 15, marginTop: 15, marginBottom: 15}}
          >
            查看题目
          </WizButton>
          <WizButton type={"import"}
                     style={{marginLeft: 15, marginTop: 15, marginBottom: 15}}
                     onClick={() => this.setState({
                       examQuestionImportVisible: true,
                       previewnKey: new Date().getTime()
                     })}>
            批量导入题目
          </WizButton>
        </div>
        <div>
          <WizTable columns={staticwizTabelColumns(this)} key={record['order']}
                    dataSource={this.state.questionTabelForm}/>
          <WizModal width={900} title="题目查看" visible={previewPModalFormVisible}
                    footer={<WizButton onClick={e => this.setState({previewPModalFormVisible: false})}>关 闭</WizButton>}

                    onCancel={() => {
                      this.setState({previewPModalFormVisible: false})
                    }}>
            <ChapterPreview key={previewnKey} chapterCategoryInfoList={categoryTabelForm}
                            questionIds={questionTabelForm} title={record['title']}
                            score={record['score']}/>
          </WizModal>
          <WizModal title={"题目导入"}
                    visible={examQuestionImportVisible}
                    onOk={() => {
                      this.setState({examQuestionImportVisible: false})
                    }}
                    onCancel={() => {
                      this.setState({examQuestionImportVisible: false})
                    }}
          >
            <ExamQuestionImport
              examId={this.state.id}
              callback={(data) => {
                let questionForm = [...this.state.questionTabelForm]
                if (data && data.length) {
                  data.forEach(e => {
                    if (e) {
                      e['typeChar'] = this._getValue('type', e['type'])
                      e['difficultyTitle'] = this._getValue('difficulty', e['difficulty'])
                      let order = questionForm.length + 1
                      e['order'] = order++
                      questionForm.push(e);
                    }
                  })
                }
                this.setState({questionTabelForm: questionForm})
              }
              }
            />
          </WizModal>
          <WizModal destroyOnClose
                    footer={null}
                    key={new Date().getTime()}
                    width={700} title={"题目预览"}
                    onCancel={() => {
                      this.setState({lookBankQUestionVisible: false})
                    }}
                    visible={lookBankQUestionVisible}
          >
            <BankQuestionLook record={bankQUestionData}
                              key={this.state.bankQUestionData || this.state.bankQUestionData.id || 0}

                              changeModal={() => {
                                this.setState({lookBankQUestionVisible: false})
                              }}/>
          </WizModal>
        </div>
      </>)
  }

  _renderDynamicTable() {

    const {categoryModalFormVisible, record, categoryTabelForm, questionTabelForm, dynamicWizTableInfo, text, previewPModalFormVisible, previewnKey} = this.state;
    return (
      <>

        <div>
          <WizButton
            icon="plus"
            type="primary"
            onClick={() => this.addCategoryEvent()}
            style={{marginTop: 15, marginBottom: 15}}
          >
            选择题目分类
          </WizButton>
          <WizButton
            onClick={() => {
              let errorMsg = text ? text : this.titleValidate(record.title)
              errorMsg = errorMsg ? errorMsg : this.scoreValidate(record.score)
              if (errorMsg) {
                wizNotice.error(errorMsg)
              } else if (categoryTabelForm && categoryTabelForm.length > 0) {
                this.setState({
                  previewPModalFormVisible: true,
                  previewnKey: new Date().getTime()
                })
              } else {
                wizNotice.error("请设置章节题目后查看")
              }
            }}
            style={{marginLeft: 15, marginTop: 15, marginBottom: 15}}
          >
            查看题目
          </WizButton>
        </div>
        <WizModalForm {...this._getModalDynamicProps(dynamicWizTableInfo, categoryModalFormVisible, 0)} />
        <WizModal width={900} title="题目查看" visible={previewPModalFormVisible}
                  footer={<WizButton onClick={e => this.setState({previewPModalFormVisible: false})}>关 闭</WizButton>}

                  onCancel={() => {
                    this.setState({previewPModalFormVisible: false})
                  }}>
          <ChapterPreview key={previewnKey} chapterCategoryInfoList={categoryTabelForm} questionIds={questionTabelForm}
                          title={record['title']} score={record['score']}/>
        </WizModal>
        <div>
          <WizTable columns={dynamicWizTableColumns(this, record['score'])} key={record['order']}
                    dataSource={categoryTabelForm}/>
        </div>
      </>)
  }

  //随机抽题form
  _categoryModalForm() {
    const {record, categoryTabelForm} = this.state;
    let count = 0
    let score = 0
    if (categoryTabelForm && categoryTabelForm instanceof Array && categoryTabelForm.length > 0) {
      count = categoryTabelForm.map(p => p['total']).reduce((prev, next) => (parseInt(prev) || 0) + (parseInt(next) || 0))
      if (record['score']) {
        score = record['score'] * count
      }
    }
    let message = `共${count}题,共${score}分`
    return (
      <>

        <WizAlert message={message} type="info" showIcon/>
        {this._renderDynamicTable()}
      </>
    )
  }

  //固定章节form
  _questionModalForm() {

    const {record, questionTabelForm} = this.state;
    let count = 0
    let score = 0
    if (questionTabelForm && questionTabelForm instanceof Array && questionTabelForm.length > 0) {
      count = questionTabelForm.length
      if (record['score']) {
        score = record['score'] * count
      }
    }
    let message = `共${count}题,共${score}分`
    return (
      <>

        <WizAlert message={message} type="info" showIcon/>
        {this._renderStaticTable()}
      </>
    )
  }

  //右侧章节信息上部分
  _renderChapterInfo() {
    let {currentIndex, record} = this.state
    let rightInfo = null
    let titleModalForm = null
    if (!record['tabelType']) {
      record['tabelType'] = 'static'
    }
    let textInfo = '[' + this._getValue('chapter', record['type']) + '题目章节]'
    if (currentIndex !== -1) {
      titleModalForm = this._titleModalForm()
      if (record['type'] === 1) {
        rightInfo = this._renderStaticTable()
      } else if (record['type'] === 2) {
        rightInfo = this._renderDynamicTable()
      } else if (record['type'] === 0) {
        rightInfo = this._renderMultipleTable()
      } else {
        textInfo = ''
      }
    } else {
      textInfo = ''
    }

    return (
      <div className='chapter-info'>
        <div className='chapter-info-title'>
          <WizTypography.Text className='title'>
            {'章节信息'}
            <WizTypography.Text className='contnet'>
              {textInfo}
            </WizTypography.Text>
          </WizTypography.Text>
        </div>
        <div className='chapter-info-body'>
          {titleModalForm}
          {rightInfo}
        </div>
      </div>
    )
  }

  stepView = () => {
    const {data, lookModalFormVisible, lookModalKey, id, copyExam, copyExamId} = this.state

    let titleCount = 0
    let scoreCount = 0
    if (data && data instanceof Array && data.length > 0) {
      data.forEach((value, index) => {
        if (value['questionTabelForm'] && value['questionTabelForm'] instanceof Array) {
          titleCount = titleCount + value['questionTabelForm'].length * 1
          let pattern = /^(([1-9][0-9]*)|(([0]\.5|[1-9][0-9]*\.5)))$/

          if (value['score'] && pattern.test(value['score'])) {
            scoreCount = scoreCount + (value['questionTabelForm'].length * value['score'])
          }
        }
        if (value['categoryTabelForm'] && value['categoryTabelForm'] instanceof Array) {
          value['categoryTabelForm'].forEach((categoryTabel, key) => {
            titleCount = titleCount + categoryTabel['total'] * 1
            if (value['score']) {
              scoreCount = scoreCount + (categoryTabel['total'] * value['score'])
            }
          })
        }
      })
    }
    this.scoreCount = scoreCount
    return (
      <>
        <div className='chapter-page'>
          <WizRow>
            <WizCol span={7} className='chapter-col'>
              {this._renderChapterMenu()}
            </WizCol>
            <WizCol span={17}>
              {this._renderChapterInfo()}
            </WizCol>
          </WizRow>
        </div>

        <div className="table-row">
          <div className="outline-font">考试概要</div>
        </div>
        <div className="div-outline">
          {this.outlineView(data.length, '总章节数', {color: '#3D80E3'})}
          <span className="separator"/>
          {this.outlineView(titleCount, '总题目数', {color: '#3DE3D5'})}
          <span className="separator"/>
          {this.outlineView(scoreCount, '总分数', {color: '#E3773D'})}
        </div>
        <div className="form-btns row-item table-row" style={{textAlign: 'center'}}>
          <WizButton title="上一步" onClick={e => this.prev(id)}>上一步</WizButton>
          <WizButton title="下一步" type="primary" onClick={e => this.saveChapter('Next')}>保存并进入下一步</WizButton>
          <WizButton title="保存" onClick={e => this.saveChapter('Return')}>保存并返回</WizButton>
          <WizButton title="预览" onClick={e => this.lookPreviewInfo()}>预览</WizButton>
          <WizButton title="重置" onClick={e => this.reset()}>重置</WizButton>

          <WizModal width={1200} title="考试预览" visible={lookModalFormVisible}
                    footer={<WizButton onClick={e => this.setState({lookModalFormVisible: false})}>关 闭</WizButton>}

                    onCancel={() => {
                      this.setState({lookModalFormVisible: false})
                    }}>
            <LookPreview key={lookModalKey} record={data} id={copyExam ? copyExamId : id} lookType='exam'
                         score={scoreCount}/>
          </WizModal>
        </div>
      </>
    )
  }

  _render() {
    let {examLoading} = this.props
    let wizCustomStepsProps = {
      header: [
        {title: '考试信息'},
        {title: '考试章节'},
        {title: '受众设置'}
      ],
      current: 1,
      content: this.stepView(),
      footer: null
    }
    return <Spin tip={'加载中'} spinning={examLoading}>
      <WizCustomSteps {...wizCustomStepsProps} />
    </Spin>

  }

  fitterFieldsValue(data) {
  }

  reset() {
    let _nextState = this._updateStateForChapterInfo(this.props.chapterInfo)
    this.setState({ ..._nextState })
  }

  lookPreviewInfo() {
    let data = this.state.data
    let errorCount = 0
    if (data && data.length) {
      data.forEach(e => {
        let errorMsg = e['text'] ? e['text'] : this.titleValidate(e['title'])
        errorMsg = errorMsg ? errorMsg : this.scoreValidate(e['score'])
        let num = 0
        if (errorMsg) {
          errorCount++
          wizNotice.error(errorMsg)
        } else if (e['type'] === 0) {
          if (e['questionTabelForm'] && e['questionTabelForm'].length > 0) {
            num += e['questionTabelForm'].length
          }
          if (e['categoryTabelForm'] && e['categoryTabelForm'].length > 0) {
            num += e['categoryTabelForm'].length
          }
          if (num === 0) {
            errorCount++
            wizNotice.error('综合章节' + e['title'] + '不存在对应的固定题目信息或抽题信息')
          }
        } else if (e['type'] === 1 && !(e['questionTabelForm'] && e['questionTabelForm'].length > 0)) {
          errorCount++
          wizNotice.error("固定章节" + e['title'] + "题目为空，请设置题目!")
        } else if (e['type'] === 2 && !(e['categoryTabelForm'] && e['categoryTabelForm'].length > 0)) {
          errorCount++
          wizNotice.error("随机章节" + e['title'] + "题目为空，请设置题目!")
        }
      })
    } else {
      errorCount++
      wizNotice.error("章节为空，请设置!")
    }
    if (errorCount <= 0) {
      this.setState({
        lookModalFormVisible: true,
        lookModalKey: new Date().getTime()
      })
    }
  }

  prev(examId) {
    this.doActions([
      {
        path: 'exam/getExamById',
        payload: {
          key: 'exam@getExamById',
          apiParams: {id: examId}
        }
      }
    ])
  }

  saveChapter(status) {
    const {data, id, type} = this.state
    let fitterValues = {};
    fitterValues['id'] = id
    fitterValues['chapterInfoList'] = []
    if (this.scoreCount > 1000) {

      wizNotice.error('考试总分不能大于1000')
      return false
    }
    for (let index = 0; index < data.length; index++) {

      let record = data[index]
      let chapterInfo = {}
      if ("temp" != type) {
        chapterInfo['id'] = record['id']
      }
      let titleMsg = this.titleValidate(record['title'])
      if (titleMsg) {

        this.handleClick(data[index], index)
        wizNotice.error(titleMsg)
        return false
      } else {
        chapterInfo['title'] = record['title']
      }
      let scoreMsg = this.scoreValidate(record['score'])
      if (scoreMsg) {
        this.handleClick(data[index], index)
        wizNotice.error(scoreMsg)
        return false
      } else {
        chapterInfo['score'] = record['score']
      }

      if (record['type'] || record['type'] === 0) {
        chapterInfo['type'] = record['type']
      } else {
        this.handleClick(data[index], index)
        wizNotice.error('无效的章节类型')
        return false
      }
      chapterInfo['order'] = index
      //固定章节
      let multipleHaveInfo = false
      if (chapterInfo['type'] === 1 || chapterInfo['type'] == 0) {
        if (record['questionTabelForm'] instanceof Array && record['questionTabelForm'].length > 0) {
          multipleHaveInfo = true
          chapterInfo['questionIds'] = record['questionTabelForm'].map(p => {
            return {questionId: p['id'], questionType: p['questionType'],difficulty: p['difficulty']}
          })
        } else if (chapterInfo['type'] == 1) {
          this.handleClick(data[index], index)
          wizNotice.error('【' + record['title'] + '】章节不存在题目信息')
          return false
        }
        //随机章节
      }
      if (chapterInfo['type'] === 2 || chapterInfo['type'] == 0) {
        chapterInfo['chapterCategoryInfoList'] = []
        if (record['categoryTabelForm'] instanceof Array && record['categoryTabelForm'].length > 0) {
          multipleHaveInfo = true
          record['categoryTabelForm'].forEach((val, index) => {
            if (val.questionCategory instanceof Array && val['questionCategory'].length > 0) {
              chapterInfo['chapterCategoryInfoList'].push({
                id: val.id,
                total: val.total,
                difficulty: val.difficulty,
                type: val.type,
                order: index,
                categoryId: val['questionCategory'][0]['value'],
              })
              if ("temp" === type) {
                chapterInfo['chapterCategoryInfoList'][0]['id'] = null
              }
            } else {
              this.handleClick(data[index], index)
              wizNotice.error('【' + record['title'] + '】章节所选分类信息异常')
              return false
            }
          });
        } else if (chapterInfo['type'] == 2) {
          this.handleClick(data[index], index)
          wizNotice.error('【' + record['title'] + '】章节不存在题目分类信息')
          return false
        }
      }
      if (chapterInfo['type'] === 0 && multipleHaveInfo === false) {
        this.handleClick(data[index], index)
        wizNotice.error('【' + record['title'] + '】综合章节不存在对应的固定题目信息或抽题信息')
        return false
      }
      fitterValues['chapterInfoList'].push(chapterInfo)

    }
    // let fitterValues = this.fitterFieldsValue(this.state.data)

    this.doActions([
      {
        path: 'exam/saveChapter',
        payload: {
          key: 'saveExam' + status + 'Key',
          apiParams: {
            ...fitterValues
          }
        }
      },
    ]);
  }

  /**概要内容 */
  outlineView(count, title, countColor) {
    return (
      <span className="outline-view">
        <div className="outline-count" style={countColor}>{count}</div>
        <div className="outline-title">{title}</div>
      </span>
    )
  }

}

const mapStateToProps = (state, ownProps) => {
  const {exam, examTemplate} = state;
  const {type} = getParamRecord(ownProps.history)
  let chapterInfo = {}
  if ('temp' === type) {
    chapterInfo = modelUtils.getModelEntity(examTemplate, "examTemplateChapter");
  } else {
    chapterInfo = modelUtils.getModelEntity(exam, "chapterInfoKey");
  }
  const saveExamReturn = modelUtils.getModelEntity(exam, "saveExamReturnKey");
  const saveExamNext = modelUtils.getModelEntity(exam, "saveExamNextKey");
  const examDetailInfo = modelUtils.getModelEntity(exam,'exam@getExamById')

  const load = modelUtils.getLoadingState(state, ['exam']);
  return {
    chapterInfo,
    saveExamReturn,
    saveExamNext,
    examDetailInfo,
    ...load
  }
};

export default connect(mapStateToProps)(ExamChapter);
